const _ = require('lib/underscore')
const ProfileUser = require('module/user/profile_user')
const Cart = require('module/user/cart')
const getSpotlightData = require('module/user/helpers/get_spotlight_data')
const log = require('log').create('viewer') // eslint-disable-line


// TODO
// revisit old functionality:

// - mapped ?
//     if (g.MAPPED) {
//         this.getMappedUserName()


const ViewerModel = ProfileUser.extend({

    initialize(options) {
        ProfileUser.prototype.initialize.apply(this, arguments)
        this.cart = new Cart()
    },

    hasAction(action) {
        return !! this.get('actions').get(action)
    },

    // track an action, but only if they haven't already done it
    // pass options.force: true to update the date stamp for an existing action
    trackAction(action, { force } = {}, cb) {
        if (this.hasAction(action) && ! force) {
            // This assumes callback is always wanted,
            // even if user already has the action.
            // Only `accepted_terms` is using this.
            // Nothing is using `force`.
            if (cb) return cb()
            return
        }
        this.get('actions').patch(action, Date.now())
            .always(() => {
            // ignore errors
                if (cb) return cb()
            })
    },

    getSpotlightModelToSave(model) {
        // determine whether to save to user.spotlight or user.spotlight_trial.
        // have to access this.attributes directly to bypass the calc'd getter
        // for spotlight, defined below
        const { spotlight, spotlight_trial } = this.attributes

        const data = getSpotlightData(model.toJSON())

        // if it's not premium, save to regular spotlight
        if (! data.is_premium) return spotlight

        // if user is already pro, save to regular spotlight
        if (this.hasFeature('upgrade')) return spotlight

        // free user is trying to save a pro spotlight, so save to spotlight_trial
        return spotlight_trial
    },
})

ViewerModel.prototype.calculated_values = _.extend({}, ProfileUser.prototype.calculated_values, {
    admin() {
        // shortcut for admin flag so we can use Viewer.is('admin') all over the place
        return this.get('logged_in') && this.get('flags.admin')
    },
    spotlight() {
        // calc'd getter for the spotlight model
        // if the user has a valid trial spotlight, return that model
        // else return the regular spotlight model

        const { spotlight, spotlight_trial } = this.attributes
        if (! spotlight_trial) return spotlight

        const valid = !! getSpotlightData(spotlight_trial.toJSON())
        if (valid) return spotlight_trial

        return spotlight
    },
})

module.exports = ViewerModel
